class PerspectiveHover extends window.BAO.CustomElement {
  constructor () {
    super()

    this.update = this.update.bind(this)

    this.counter = 0
    this.updateRate = 5
  }

  setupListeners () {
    super.setupListeners()

    if (window.innerWidth >= 768) {
      this.listeners.add(this, 'mouseenter', this.onMouseEnter.bind(this))
      this.listeners.add(this, 'mouseleave', this.onMouseLeave.bind(this))
      this.listeners.add(this, 'mousemove', this.onMouseMove.bind(this))
    }
  }

  onMouseEnter (event) {
    this.update(event)
  }

  onMouseLeave () {
    this.els.inner.element.style = ''
  }

  onMouseMove (event) {
    if (this.shouldUpdate) {
      this.update(event)
    }
  }

  update (event) {
    const container = this.els.inner.element
    const rect = container.getBoundingClientRect()

    const x = ((event.clientX - rect.left) / container.offsetWidth) * 100 - 50
    const y = ((event.clientY - rect.top) / container.offsetHeight) * 100 - 50

    this.els.inner.element.style.transform = `rotateX(${-y /
      100}deg) rotateY(${x / 100}deg)`
  }

  get shouldUpdate () {
    return this.counter++ % this.updateRate === 0
  }
}

if (!customElements.get('perspective-hover')) {
  customElements.define('perspective-hover', PerspectiveHover)
}
